<template>
  <footer class="app-footer">
    <div class="footer fixed">
      <!-- 添加QQ群链接 -->
      <span
          style="background-color: #4CAF50; padding: 5px 10px; border-radius: 5px; color: white; font-weight: bold;margin-right: 10px">
        用户反馈QQ群 779841732
      </span>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="beian-link">
        京ICP备2025106549号
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>

<style scoped>
.app-footer {
  margin-top: -50px;
  width: 100%;
  padding: 15px 0;
  color: #6b7280;
  text-align: center;
  margin-left: 80px;
}

.footer-content {
  font-size: 14px;
  line-height: 1.5;
}

.footer-content span {
  margin: 0 8px;
}

.divider {
  color: #d1d5db;
}

.beian-link {
  color: #6b7280;
  text-decoration: none;
  transition: color 0.3s ease;
}

.beian-link:hover {
  color: #6366f1;
  text-decoration: underline;
}
</style>
